import { Module } from "wrapper6";
import $ from 'jquery';

export default class FindPerson extends Module {

    ready() {
        const AREA_WRAPPER = '#areas';
        const AREA_SELECTOR = '#areas li';
        const COUNTRY_SELECTOR = '#countries li';
        const COUNTRY_WRAPPER = '#countries';
        const PERSON_SELECTOR = '.more-person';
        const MORE_WRAPPER = '.more-person-wrapper';
        let SELECTED_COUNTRY = 0;

        /*
        * Area selection
        * */

        $(document).on('click', AREA_SELECTOR, function () {
            const personWrap = $(this).closest('.contact-box').find('.person');
            const curSelect = $('.country-select.active').data('id');
            if(curSelect){
                SELECTED_COUNTRY = curSelect;
            }

            let id = $(this).data('id');

            $('.area-select.active').removeClass('active');
            $(this).addClass('active');
            personWrap.addClass('hidden');

            // Set ajax data
            let data = {
                'action': 'find_countries',
                'id': id,
            };

            let position = $(this).position().left;
            if($(this).prev().length){
                position = $(this).prev().position().left;
            }

            $(AREA_WRAPPER).animate({scrollLeft: position + $(AREA_WRAPPER).scrollLeft()}, 500);

            // Ajax call
            jQuery.post(main_theme_objects.ajax_url, data, function (response) {
                $(COUNTRY_WRAPPER).html(buildCountryList(response.countries));
            });

        });

        function mobilecheck() {
            return window.innerWidth <= 1280;
        }

        function buildCountryList(countries){

            let template = function(c) {
                let active = c.term_id===SELECTED_COUNTRY?"active":"";
                return '<li class="country-select '+active+'" data-slug="'+c.slug+'" title="'+c.name+'" data-id="'+c.term_id+'">'+c.name+'</li>'
            };

            let html = '';
            for (let i = 0; i <= Object.keys(countries).length; i++) {
                const country = countries[i];
                if(country) html += template(country);
            }
            return html;
        }


        /*
        * Country selection
        * */

        $(document).on('click', COUNTRY_SELECTOR, function () {
            const personWrap = $(this).closest('.contact-box').find('.person');
            const slug = $(this).data('slug');

            $('.country-select.active').removeClass('active');
            $(this).addClass('active');

            // Set ajax data
            let data = {
                'action': 'find_persons',
                'slug': slug,
            };

            // Ajax call
            jQuery.post(main_theme_objects.ajax_url, data, function (response) {
                $(MORE_WRAPPER).html(buildContactPerson(response));
                let defaultInfo = response.fields[0];
                let defaultImage = response.imgs[0];
                $('#name').html(defaultInfo.name);
                $('#position').html(defaultInfo.position);
                $('#phone').html(defaultInfo.phone);
                $('#phone').attr('href', 'tel:' + defaultInfo.phone);
                $('#mail').html(defaultInfo.email);
                $('#mail').attr('href', 'mailto:' + defaultInfo.email);
                $('#image').attr('src', defaultImage.full);
                $('#vcard').attr('href', defaultInfo.vcard ? defaultInfo.vcard.url : null);
                personWrap.removeClass('hidden');

                $('html, body').animate({
                    scrollTop: $('.person').offset().top - 100
                }, 'normal');
            });

        });

        function buildContactPerson(contacts){
            let template = function(c, thumb, active = '', fields = null) {

                let text = '';

                if(!thumb){
                    let nameArr = fields.name.split(' ');
                    text = nameArr[0][0]+nameArr[1][0];
                }

                return '<div data-id="'+c.ID+'" style="background-image:url('+thumb+');" class="more-person '+active+'">'+text+'</div>'
            };

            let html = '';
            for (let i = 0; i <= Object.keys(contacts.persons).length; i++) {
                const person = contacts.persons[i];
                const thumb = contacts.imgs[i] ? contacts.imgs[i]['thumb'] : null;
                if(person) {
                    let active = i===0 ? 'active' : '';
                    html += template(person, thumb, active, contacts.fields[i]);
                }
            }

            if(Object.keys(contacts.persons).length > 1){
                $('.more').removeClass('hidden');
            } else {
                $('.more').addClass('hidden');
            }
            return html;
        }


        /*
        * Person selection
        * */

        $(document).on('click', PERSON_SELECTOR, function () {
            const id = $(this).data('id');

            $('.more-person.active').removeClass('active');
            $(this).addClass('active');

            // Set ajax data
            let data = {
                'action': 'find_person',
                'id': id,
            };

            // Ajax call
            jQuery.post(main_theme_objects.ajax_url, data, function (response) {
                let defaultInfo = response.fields;
                let defaultImage = response.imgs;
                $('#vcard').attr('href',defaultInfo.vcard.url);
                $('#name').html(defaultInfo.name);
                $('#position').html(defaultInfo.position);

                $('#phone').attr('href','tel:' + defaultInfo.phone.replace(/\s/g, ''));
                $('#phone').html(defaultInfo.phone);
                
                $('#mail').attr('href','mailto:' + defaultInfo.email.replace(/\s/g, ''));
                $('#mail').html(defaultInfo.email);

                $('#image').attr('src', defaultImage.full ? defaultImage.full : null);
            });

        });

    }



}